
import Vue from 'vue';
import { Component, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ReadyType } from '@/stores/ready.store';
import { Content } from '@/interfaces/components/content';

const Routing = namespace('routing');
const User = namespace('user');

@Component({
	name: 'StaticPage',
})
export default class StaticPage extends Vue {
	@Ref('content') readonly content!: Content;

	@Routing.State urlMetadata: any;
	@Routing.State urlMetadataPromise: Promise<any>;

	@User.Getter bestEffortId: string;

	updated() {
		this.content.scrollToTop();
		this.updateScript();
	}

	async created() {
		await this.urlMetadataPromise;
		await Vue.$jw.ready?.waitFor(ReadyType.JW_ID);
	}

	updateScript() {
		if (this.urlMetadata?.html_content?.script) {
			const pageScript = new Function(this.urlMetadata.html_content.script);
			pageScript();
		}
	}

	async mounted() {
		this.updateScript();
	}

	get htmlContent() {
		return (this.urlMetadata?.html_content.default || this.urlMetadata?.html_content?.compile || '').replace(
			new RegExp('{{BEST_EFFORT_ID}}', 'g'),
			this.bestEffortId
		);
	}

	get firstChoice() {
		return this.urlMetadata?.html_content?.first_choice
			? JSON.parse(this.urlMetadata.html_content.first_choice)
			: undefined;
	}

	get pageType() {
		if (this.urlMetadata?.meta_title === 'TV Code') {
			return 'tvcode';
		}

		return this.urlMetadata?.html_content?.landing_page_type || 'static';
	}
}
